import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/profile')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/profile' })
  },
  component: () => null,
})
